import React, { Component } from "react";

class ImportDataViews extends Component {
  render() {
    return (
      <>
        <div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div id="detalleCertificado">
                  <fieldset>
                    <legend>DATOS IMPORTACIÓN</legend>

                    <div className="row">
                      <div className="col-lg-8">
                        <div className="form-group">
                          <label>Tipo:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .tipo_producto_importacion
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>Guía aréa:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .guia_area
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>No.Factura:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .no_factura
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-8">
                        <div className="form-group">
                          <label>Importador:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .importador_razon_social
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>Código DISAAN importador:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .codigo_disaan_importador
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-8">
                        <div className="form-group">
                          <label>Fabricante:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .fabricante_razon_social
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>Código DISAAN fabricante:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .codigo_disaan_fabricante
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>País de origen:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .pais_origen_nombre
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>País de procedencia:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .pais_procedencia_nombre
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>Solicitado por:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .nombre_solicitante
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <div className="col-lg-12">
                        {this.props.state.caso_especial.tipo_importacion_id ===
                        "7" ? (
                          <table className="table table-striped mb-0 table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">Materia Prima</th>
                                <th className="text-center">País de origen</th>
                                {this.props.state.caso_especial
                                  .datos_importacion
                                  .tipo_producto_importacion !==
                                "PRODUCTOS UTILIZADOS EN ALIMENTACIÓN ANIMAL" ? (
                                  <th className="text-center">Fabricante</th>
                                ) : null}
                                <th className="text-center">Presentación</th>
                                <th className="text-center">Cantidad</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.state.caso_especial.productos.length >
                              0 ? (
                                this.props.state.caso_especial.productos.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="text-center" width={"20%"}>
                                        {item.nombre_materia_prima}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.pais_origen_nombre}
                                      </td>
                                      {this.props.state.caso_especial
                                        .datos_importacion
                                        .tipo_producto_importacion !==
                                      "PRODUCTOS UTILIZADOS EN ALIMENTACIÓN ANIMAL" ? (
                                        <td
                                          className="text-center"
                                          width={"20%"}
                                        >
                                          {item.fabricante_razon_social}
                                        </td>
                                      ) : null}
                                      <td className="text-center" width={"20%"}>
                                        {item.presentacion}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.cantidad}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center">
                                    No se encontraorn productos listados
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        ) : (
                          <table className="table table-striped mb-0 table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">
                                  Nombre comercial
                                </th>
                                {!["1", "8"].includes(
                                  this.props.state.caso_especial
                                    .tipo_importacion_id
                                ) ? (
                                  <th className="text-center">
                                    País de origen
                                  </th>
                                ) : null}
                                <th className="text-center">Presentación</th>
                                <th className="text-center">Especie</th>
                                <th className="text-center">Categoría</th>
                                <th className="text-center">País origen</th>
                                <th className="text-center">Cantidad</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.state.caso_especial.productos.length >
                              0 ? (
                                this.props.state.caso_especial.productos.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="text-center" width={"20%"}>
                                        {item.nombre_comercial}
                                      </td>
                                      {!["1", "8"].includes(
                                        this.props.state.caso_especial
                                          .tipo_importacion_id
                                      ) ? (
                                        <td
                                          className="text-center"
                                          width={"20%"}
                                        >
                                          {item.pais_origen_nombre}
                                        </td>
                                      ) : null}

                                      <td className="text-center" width={"20%"}>
                                        {item.presentacion}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.especie_nombre}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.categoria_nombre}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.pais_origen_nombre}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.cantidad}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center">
                                    No se encontraorn productos listados
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>Petición:</label>
                          <textarea
                            className="form-control"
                            defaultValue={
                              this.props.state.caso_especial.datos_importacion
                                .peticion
                            }
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  {!["1", "7", "8"].includes(
                    this.props.state.caso_especial.tipo_importacion_id
                  ) ? (
                    <fieldset>
                      <legend>DATOS ESTABLECIMIENTO</legend>

                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Razón social:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .razon_social
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Dirección:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .direccion
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Cédula RUC:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .cedula_ruc
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Correo electrónico:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .correo_electronico
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Teléfono:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .telefono
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Representante legal:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .representante_legal
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  ) : null}

                  <hr />

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="btn-group  pull-left">
                        <button
                          className="btn btn-danger "
                          onClick={() => {
                            this.props.handleModalImportDataCloseBtn();
                          }}
                        >
                          Regresar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ImportDataViews;
